<template>
  <div class="card anomaly-card" :class="toneClass" role="button" tabindex="0" @click="$emit('click')">
    <div class="card-header card-no-border pb-10">
      <div class="anomaly-row" style="float: right;">
        <div class="anomaly-col">
          <h3 class="anomaly-value">{{ value }}</h3>
        </div>
      </div>
      <h5 class="anomaly-title">{{ title }}</h5>
      <span class="anomaly-subtitle">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnomalyMetricCard",
  emits: ["click"],
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    label: { type: String, default: "Periodo" },
    value: { type: [Number, String], default: 0 },
    tone: {
      type: String,
      default: "income",
      validator: v => ["income", "expense"].includes(v),
    },
  },
  computed: {
    toneClass() {
      return this.tone === "expense" ? "is-expense" : "is-income";
    },
  },
};
</script>

<style scoped>
.anomaly-card {
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
}

.anomaly-card .card-header {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.anomaly-card .card-body {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.anomaly-title {
  margin-bottom: 0;
  font-size: 18px;
}

.anomaly-subtitle {
  color: #6b7280;
  font-size: 13px;
}

.anomaly-row {
  display: block;
}

.anomaly-col {
  min-width: 100px;
}

.anomaly-label {
  display: block;
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 2px;
}

.anomaly-value {
  margin: 0;
  font-size: 34px;
  font-weight: 500;
  text-align: right;
}

.anomaly-card.is-income .anomaly-value {
  color: rgb(115, 102, 255);
}

.anomaly-card.is-expense .anomaly-value {
  color: rgb(247, 49, 100);
}
</style>
